// src/pages/NegociosComunidade.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  listenNegociosComunidade,
  criarNegocio,
} from '../services/negociosService';

import NegocioCard from '../components/negocios/NegocioCard';
import NegocioFormModal from '../components/negocios/NegocioFormModal';

export default function NegociosComunidade() {
  const { usuario } = useAuth() || {};
  const [negocios, setNegocios] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!usuario?.uid) return;
    const unsub = listenNegociosComunidade(usuario.uid, setNegocios);
    return unsub;
  }, [usuario?.uid]);

  const handleNovo = () => setOpenModal(true);

  const handleSave = async (dados) => {
    if (!usuario) return;
    setSalvando(true);

    try {
      // força visibilidade = comunidade
      dados.visibilidade = 'comunidade';

      await criarNegocio({ usuario, dados });
      setOpenModal(false);
    } catch (err) {
      console.error('Erro ao salvar negócio', err);
      alert('Erro ao salvar negócio. Tente novamente.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="mx-auto w-full max-w-6xl space-y-4 p-6">
      <div className="flex items-center justify-between gap-2">
        <div>
          <h1 className="text-lg font-semibold text-zinc-900">
            Negócios da Comunidade
          </h1>
          <p className="text-sm text-zinc-600">
            Veja o que outros corretores estão buscando e gere negócios em
            parceria.
          </p>
        </div>

        <button
          onClick={handleNovo}
          className="rounded-xl bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700"
        >
          + Novo Negócio
        </button>
      </div>

      {negocios.length === 0 ? (
        <div className="mt-6 rounded-xl border border-dashed border-zinc-300 bg-white p-6 text-center text-sm text-zinc-500">
          Ainda não há negócios cadastrados pela comunidade.
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {negocios.map((n) => (
            <NegocioCard key={n.id} negocio={n} modo="comunidade" />
          ))}
        </div>
      )}

      <NegocioFormModal
        open={openModal}
        onClose={() => {
          if (!salvando) setOpenModal(false);
        }}
        onSave={handleSave}
      />
    </div>
  );
}
